import { ILoungeConfig, IReplaceSvg } from './lounge-config.interface';

/** Config for supplying configuration for the Lounge module */
export class LoungeConfig implements ILoungeConfig {
  /** Used for defining which SVG icons to replace.
   * @see {@link IReplaceSvg} */
  replaceSvgs: IReplaceSvg[] = [];
}
